import { TimelineMax, TweenMax } from "gsap";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import App from '../../../vendor_core/core/src/App';
import BBModel from "../model/BBModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import Utils from '../../../vendor_core/core/src/utils/Utils';
import SpineAnimation from '../../../vendor_core/core/src/views/SpineAnimation';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import BBReelGroup from '../view/BBReelGroup';
import BBUtils from './utils';
import BBReelSymbol from '../view/BBSymbol';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";

const playBeatLogoAnim = () => {
    const logoAnim = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().spineAnimations.get("logo");
    logoAnim.playAsync("beat").then(() => logoAnim.play());
}
const playThunderLogoAnim = () => {
    const logoAnim = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().spineAnimations.get("logo");
    logoAnim.playAsync("win", 0.4).then(() => {
        logoAnim.play();
    });
}
const playTornadoAnimations = (onComplete: () => void) => {
    const scene = ViewManager.getLayer("Tornado").setScene("open");
    const tornadoAnim = scene.spineAnimations.get("tornado");
    tornadoAnim.playAsync(undefined, 2.5).then(onComplete);
}

const playTextPopupBanner = (text: string, time: number, toAlpha: number, onCompleteFunk?: [() => void], onStartFunk?: [() => void]) => {
    const scene = ViewManager.getLayer("FsBanner").setScene("open");
    const banner = scene.sceneTextFields.get("title") as TextField;
    const reelBorder = ViewManager.getLayer(DefaultLayers.ReelsBack).getCurrentScene().sceneSprites.get("border");

    let newStyle = Utils.deepClone(banner.style)
    newStyle.fill = [0x65a0eb]
    banner.updateStyle(newStyle)
    banner.text = text;
    onStartFunk && onStartFunk.length > 0 ? onStartFunk.forEach(funk => funk()) : null;



    let tween = TweenMax.fromTo(banner, 2,
        {
            x: Layout.isLandscape() ? reelBorder.x + reelBorder.width / 2 : banner.x + banner.width * 3 / 4,
            y: Layout.isLandscape() ? reelBorder.y + reelBorder.height / 2 : banner.y + banner.height * 0.5,
            width: 1,
            height: 1,
        },
        {
            x: banner.x,
            y: banner.y,
            width: banner.width,
            height: banner.height,
            alpha: toAlpha,
            onComplete: () => {
                TweenMax.delayedCall(1, () => ViewManager.getLayer("FsBanner").clear())
                onCompleteFunk && onCompleteFunk.length > 0 ? onCompleteFunk.forEach(funk => funk()) : null;
                // TweenMax.to(banner, time, {
                //     alpha: 0,
                //     // onComplete: () => this.tween.play()
                // });
            }
        }
    )

    scene.on(PointerEvents.DOWN, () => {
        if (tween) {
            tween.kill();
        }
        ViewManager.getLayer("FsBanner").clear()
    })

    scene.interactive = true;
}

const playStartGameSymbolAnimations = (reelGroup: BBReelGroup) => {
    reelGroup.reels.forEach(reel => {
        reel.symbols.forEach(symbol => {
            if (symbol.id === 0) {
                (symbol as BBReelSymbol).playSpineAnim("tornado_mode")
            } else {
                (symbol as BBReelSymbol).playSpineAnim()
            }
        });
    })
}

const playThunderBoltMultiStrike = (symbol: BBReelSymbol) => {
    const reelScene = ViewManager.getLayer("Thunder").setScene("open");
    const thunderAnim = reelScene.spineAnimations.get("lightning");

    // const setThunderAnimSingleShotPosition = () => {
    //     thunderAnim.position.x = symbol.position.x
    //     thunderAnim.position.y = symbol.position.y - (thunderAnim.height * 0.4);
    // }
    const setThunderAnimLightningStrikePosition = () => {
        thunderAnim.position.set(symbol.position.x, symbol.position.y);
    }

    // setThunderAnimSingleShotPosition();
    // thunderAnim.play("single_shot");
    // thunderAnim.playAsync("single_shot").then(() => {
    setThunderAnimLightningStrikePosition();
    thunderAnim.playAsync("lightning_strike").then(() => {
        ViewManager.getLayer("Thunder").clear()
    })
    // })
}
const playThunderBoltSingleShot = (symbol: BBReelSymbol) => {
    const reelScene = ViewManager.getLayer("Thunder").setScene("open");
    const thunderAnim = reelScene.spineAnimations.get("lightning");

    // console.log(thunderAnim.height * Layout.globalScale);
    // console.log(symbol.parent.height);
    // console.log(symbol.y);


    const setThunderAnimSingleShotPosition = () => {
        thunderAnim.position.x = symbol.position.x;
        thunderAnim.position.y = symbol.position.y - (500 * Layout.globalScale);
        // thunderAnim.position.y = symbol.position.y - (symbol.parent.height - symbol.y) - symbol.height / 2;
    }

    setThunderAnimSingleShotPosition();
    // thunderAnim.play("single_shot");
    thunderAnim.playAsync("single_shot").then(() => {
        ViewManager.getLayer("Thunder").clear()
    })
}

const playThunderBolt = (symbol: BBReelSymbol) => {
    const reelScene = ViewManager.getLayer("Thunder").setScene("open");
    const thunderAnim = reelScene.spineAnimations.get("lightning");

    const setThunderAnimSingleShotPosition = () => {
        thunderAnim.position.x = symbol.position.x;
        // 500 is magic number :)
        thunderAnim.position.y = symbol.position.y - (500 * Layout.globalScale);
        // thunderAnim.position.y = symbol.position.y - (thunderAnim.height * 0.4);
    }
    const setThunderAnimLightningStrikePosition = () => {
        thunderAnim.position.set(symbol.position.x, symbol.position.y);
    }

    setThunderAnimSingleShotPosition();
    // thunderAnim.play("single_shot");
    thunderAnim.playAsync("single_shot").then(() => {
        setThunderAnimLightningStrikePosition();
        thunderAnim.playAsync("lightning_strike", 2).then(() => {
            ViewManager.getLayer("Thunder").clear()
        })
    })
}

const blackingSymbols = (reelGroup: BBReelGroup, symbols?: { reelIndex: number, cellIndex: number }[]) => {
    // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();
    reelGroup.reels.forEach((reel, reelIndex) => {
        let nonBlackingCell = [];
        if (symbols && symbols.length > 0) {
            nonBlackingCell = symbols.reduce((acc, data) => {
                if (data.reelIndex === reelIndex) {
                    acc.push(data.cellIndex)
                }
                return acc
            }, [])
        }
        reel.symbols.forEach((sym, rowIndex) => {
            if (!nonBlackingCell.includes(rowIndex)) {
                (sym as BBReelSymbol).spineAnim.tint = 8618883
            }
        })
    })

}
const unBlackingSymbols = (reelGroup: BBReelGroup, symbols?: { reelIndex: number, cellIndex: number }[]) => {
    reelGroup.reels.forEach((reel, reelIndex) => {
        let nonBlackingCell = [];
        if (symbols && symbols.length > 0) {
            nonBlackingCell = symbols.reduce((acc, data) => {
                if (data.reelIndex === reelIndex) {
                    acc.push(data.cellIndex)
                }
                return acc
            }, [])
        }
        reel.symbols.forEach(sym => {
            (sym as BBReelSymbol).spineAnim.tint = BBModel.symbolTint;
        })
    })
}

const playBGMainAnim = () => {
    const scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    // let bgNight = scene.sceneSprites.get("bgr_darksky");
    // let bgr = scene.sceneSprites.get("bgr");

    const bgAnim = scene.spineAnimations.get("bg");
    // bgNight.visible = false;
    // bgr.visible = true;
    // TweenMax.delayedCall(0.2, () => bgr.visible = false)
    if (SpinModel.isInFreespins()) {
        bgAnim.play("sunset", true)
    } else {
        bgAnim.play()
    }


}

const playBGNightAnim = (repeat = 61) => {
    const scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    // let bgNight = scene.sceneSprites.get("bgr_darksky");
    const bgAnim = scene.spineAnimations.get("bg");
    // bgNight.visible = true;
    // let tween = shakeScreen(bgAnim, repeat);
    // bgAnim.onCompleteOnce(() => {
    //     tween.progress(1);
    //     tween.kill();
    // })
    bgAnim.play("night", false);
}

const playTeaseDarkenScreeShake = (onComplete?: () => void) => {
    let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .getSubView("ReelGroup") as BBReelGroup;

    let destroySymbolsTimeline = new TimelineMax({ paused: false, onComplete: onComplete });

    const DESymbolData = BBUtils.getRandomSymbol(reelGroup, {
        reelInterval: {start: 2, end: 5},
        rowInterval: {start: 2, end: 5}
    });

    const DESymbol = DESymbolData.symbol;
    const wilds = reelGroup.searchWilds();
    const nonBlacking = wilds.map(wild => ({
        reelIndex: wild.x,
        cellIndex: wild.y
    }));
    nonBlacking.push({ reelIndex: DESymbolData.reelIndex, cellIndex: DESymbolData.rowIndex })

    destroySymbolsTimeline.add(() => BBAnimationsHelper.playBGNightAnim(35), 0.3);
    destroySymbolsTimeline.add(() => { BBAnimationsHelper.playThunderLogoAnim() }, 0.5);
    destroySymbolsTimeline.add(() => { BBAnimationsHelper.blackingSymbols(reelGroup, nonBlacking) }, 0.5);
    destroySymbolsTimeline.add(() => { reelGroup.DESymbolAnimation(DESymbol) }, 0.5);
    destroySymbolsTimeline.add(() => { BBAnimationsHelper.unBlackingSymbols(reelGroup, nonBlacking) }, 2.5)
    destroySymbolsTimeline.add(() => { reelGroup.idleSymbolAnimation(DESymbol) }, 2.5);
    destroySymbolsTimeline.add(() => { BBAnimationsHelper.playBGMainAnim() }, 2.5);


}

const playAnticipationAnim = (reelGroup: BBReelGroup) => {
    // ViewManager.getLayer(DefaultLayers.Anticipation).clear();
    const antiArray = [];
    // let isMobile = GameModel.isMobile();
    // let isLandscape = Layout.isLandscape();
    const anticipationScene = ViewManager.getLayer(DefaultLayers.Anticipation).getCurrentScene();
    const explodesMap = SpinModel.getCurrentCascadeExplodeMap();
    // 21 and 13 is the difference in pixels for animations on reel 2, 1, 6 and 8 !!!
    const fixAnimPositions = (anim: SpineAnimation, key: string, isMobile: boolean, isLandscape: boolean) => {
        if (isMobile && !isLandscape) {
            if (key.includes("2")) {
                anim.parent.height -= (21 * Layout.globalScale);
            }
            if (key.includes("1") || key.includes("6") || key.includes("8")) {
                anim.parent.height += (13 * Layout.globalScale);
            }
        } else if (isMobile && isLandscape) {
            anim.parent.height += (13 * Layout.globalScale);
            anim.parent.y -= (13 * Layout.globalScale);
        }
    };
    // anticipationScene.preOrientationChangeCallback = () => {
    //     let isMobile = GameModel.isMobile();
    //     let isLandscape = Layout.isLandscape();
    //     anticipationScene.spineAnimations.forEach((sp, key) => {
    //         if (isMobile && !isLandscape) {
    //             if (key.includes("2")) {
    //                 sp.parent.height += (21 * Layout.globalScale);
    //             }
    //             if (key.includes("1") || key.includes("6") || key.includes("8")) {
    //                 sp.parent.height -= (21 * Layout.globalScale);
    //             }
    //         } else if (isMobile && isLandscape) {
    //             sp.parent.height -= (13 * Layout.globalScale);
    //             sp.parent.y += (13 * Layout.globalScale);
    //         }
    //     })
    // }
    // anticipationScene.orientationChangeCallback = () => {
    //     let isMobile = GameModel.isMobile();
    //     let isLandscape = Layout.isLandscape();
    //     anticipationScene.spineAnimations.forEach((sp, key) => {
    //         fixAnimPositions(sp, key, isMobile, isLandscape);
    //     })
    // }
    reelGroup.reels.forEach(reel => {
        const explodedItems: boolean[] = explodesMap.length > 0 ? explodesMap[reel.reelIndex] : [];
        const expIt = BBUtils.getModifiedExplodedItems(reel, explodedItems)
        if (expIt.length > 0) {
            let counter = 0;
            expIt.forEach(element => {
                if (element) {
                    counter += 1
                }
            });
            antiArray.push(counter)
        } else {
            antiArray.push(0)
        }

    })
    // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();

    SoundController.stopMusic();
    const anticipationAud = SoundController.playSound("anticipation", false);
    anticipationAud.fade(0, 1, 250);

    anticipationScene.spineAnimations.forEach((sp, key) => {
        let cellNumber: number = antiArray[(Number(key.split("_")[1]) - 1)];
        if (cellNumber > 0) {
            // sp.play(cellNumber.toString())
            sp.play("8")
        }
        // fixAnimPositions(sp, key, isMobile, isLandscape);
    })
    // console.log(SoundController.currentSounds.find(sound => sound.name === "anticipation"));
    // TweenMax.delayedCall(App.config.numReels * App.config.reelSpinificationDuration, () => {
    //     anticpationAud.stop();
    // });

}

const clearAnticipation = () => {
    if (BBModel.hasAnticipation) {
        // debugger
        // console.log(SoundController.currentSounds);

        let anticipationSound = SoundController.currentSounds.find(sound => sound.name === "anticipation");
        // console.log(anticipationSound);

        // ConsoleUtil.yellow("SOUND:", anticipationSound)

        if (anticipationSound) {
            SoundController.stopSound(anticipationSound)
            let has3wilds = false;
            let wildCount = 0;

            const flatSymbols: number[][] = (SpinModel.getCurrentFinalSymbols() as any).flat();

            for (let ix = 0; ix < flatSymbols.length; ix++) {
                if (flatSymbols[ix] == GameModel.gameConfig.symbolResponseMap.WI.id) {
                    if (++wildCount == 3) {
                        has3wilds = true;
                        break;
                    }
                }
            }

            if (has3wilds) {
                SoundController.playSound('suspense_win');
                // console.log('Play win sound')
            } else {
                // console.log('Play LOSE sound')
                SoundController.playSound('suspense_lose');
            }
            SoundController.startMusic(SoundVars.MUSIC_MAIN);
        }
        ViewManager.getLayer(DefaultLayers.Anticipation).getCurrentScene().spineAnimations.forEach(anim => anim.stop(true));
        BBModel.resetAnticipation();
    }
}

const shakeScreen = (anim: SpineAnimation, repeat: number) => {
    return TweenMax.to(anim, 0.05, {
        x: `+=${100 * Layout.globalScale}`,
        // y: `+=${50 * Layout.globalScale}`,
        yoyo: true,
        repeat: repeat,
    })
}

const playEnterFreeSpinWildAnim = (timeScale: number) => {
    let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .getSubView("ReelGroup") as BBReelGroup;
    let wilds = reelGroup.searchWilds();
    wilds.forEach(wild => {
        let symbol = reelGroup.getSymbolAt(wild.x, wild.y)
        let parentSym = symbol.parent
        parentSym.removeChild(symbol);
        parentSym.addChild(symbol)
    });
    playBeatLogoAnim()
    // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();
    wilds.forEach(wild => {
        let sym = reelGroup.getSymbolAt(wild.x, wild.y);
        sym.playAsyncSpineAnim("scale_on", timeScale).then(() => {
            sym.playAsyncSpineAnim("scale_on_shine", timeScale).then(() => {
                SoundController.playSound('wild_turn');
                sym.playAsyncSpineAnim("scale_rotate_shine", timeScale).then(() => {
                    sym.playAsyncSpineAnim("scale_off_shine", timeScale).then(() => {
                        sym.playSpineAnim()
                    })
                })
            })
        })
    })
    // wilds.forEach(wild => {
    //     let sym = reelGroup.getSymbolAt(wild.x, wild.y);
    //     sym.spineAnim.playAsync("star_scale_on", timeScale).then(() => {
    //         sym.spineAnim.playAsync("star_scale_on_shine", timeScale).then(() => {
    //             SoundController.playSound('star_wild_turn');
    //             sym.spineAnim.playAsync("star_scale_rotate_shine", timeScale).then(() => {
    //                 sym.spineAnim.playAsync("star_scale_off_shine", timeScale).then(() => {
    //                     sym.defaultPlaySpineAnim()
    //                 })
    //             })
    //         })
    //     })
    // })
};


const playWindAnimation = (position: number, orientation: string) => {
    let finalOrientation;
    let animPSDName;

    if (orientation === "up") {
        finalOrientation = 9;
        animPSDName = "wind_animation";
    } else if (orientation === "down") {
        finalOrientation = 1;
        animPSDName = "wind_animation";
    } else if (orientation === "left") {
        finalOrientation = 1;
        animPSDName = "wind_animation_horisontal";
    } else if (orientation === "right") {
        finalOrientation = 9;
        animPSDName = "wind_animation_horisontal";
    }

    let windScene = ViewManager.getLayer("WindAnimation").getCurrentScene()
    windScene.anims.forEach((wind, animName) => {
        let animIndex = parseInt(animName.split(animPSDName)[1]);

        if ((position + finalOrientation) == animIndex) {
            // console.log("animIndex", animIndex);
            wind.visible = true;
            wind.animationSpeed = 0.6;
            wind.gotoAndPlay(0);
            wind.loop = false;
            wind.onComplete = () => {
                wind.visible = false;
            }

        }
    });
}

const BBAnimationsHelper = {
    playBGNightAnim,
    playThunderLogoAnim,
    playBeatLogoAnim,
    playWindAnimation,
    playThunderBolt,
    playTornadoAnimations,
    playTextPopupBanner,
    playBGMainAnim,
    playAnticipationAnim,
    shakeScreen,
    blackingSymbols,
    unBlackingSymbols,
    playEnterFreeSpinWildAnim,
    playThunderBoltSingleShot,
    playThunderBoltMultiStrike,
    playTeaseDarkenScreeShake,
    clearAnticipation,
    playStartGameSymbolAnimations
};

export default BBAnimationsHelper
